module.exports = __webpack_public_path__ + "img/about3.c33ab5fb.png";